export const error = { appearance: 'error', autoDismiss: true };
export const success = { appearance: 'success', autoDismiss: true };
